import { useEffect, useState } from "react";
import { useParams } from "react-router";
import React from 'react';
import Api from "../../Api/Api";

import Slider from "../Slider";
import { settingsBanners } from "../../Config/Slider";

import Navbar from "../Navbar";
import Latest from "../Home/Latest";
import Trending from "../Home/Trending";
import ContinueToWatch from "./ Continuetowatch";
import WatchList from "./WatchList";

import { isAuthenticated } from "../../Auth/isAuthenticated"
import { username } from "../../API";
import { Helmet } from "react-helmet-async";
import CategoriesHome from "../Home/Categeries";

const MovieContainer = ({ banner }) => {
  // const [banners, setBanners] = useState([]);
  // // const { username } = useParams();
  // useEffect(() => {
  //   const getData = async () => {
  //     const { data } = await Api.getBanners(username);
  //     const banner = data.map((bannerObj) => bannerObj.bannerimage);
  //     setBanners(banner);
  //     console.log("movibanner", banner)
  //   };
  //   getData();
  // }, [username]);
  const dummyBanner = {
    image: "https://picsum.photos/1200/400",
    title: "Explore Our Latest Videos!",
    description: "Watch the best video content from our exclusive collection and stay updated.",
  };
  return (
    <>
      <Helmet>
        <title>Videos - SoComOTT | Watch the Latest Now</title>
        <meta
          name="description"
          content="Discover and stream the latest videos, TV shows, and movies on our OTT Channel. Enjoy exclusive content and seamless streaming."
        />
        <meta
          name="keywords"
          content="Videos, Watch Online, TV Shows, Movies, Streaming Platform, Exclusive Content"
        />
        <meta name="author" content="SoComOTT Team" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </Helmet>

      <div className="px-3 px-md-5 px-lg-7 mb-5">
        <Navbar />
        {banner?.length ? <Slider data={banner} settings={settingsBanners} /> : (
          <div className="d-flex justify-content-center align-items-center w-100 mb-5" style={{ height: '50vh' }}>
            <div className="position-relative w-100" style={{ height: '100%' }}>
              <img
                src={dummyBanner.image} // Replace with your dummy image URL
                alt={dummyBanner.title || "Default Banner"}
                className="img-fluid w-100"
                style={{ height: '100%', objectFit: 'cover' }} // Set height to 100% and keep objectFit
              />
            </div>
          </div>
        )}

        {isAuthenticated() && <ContinueToWatch />}
        {/* <CategoriesHome /> */}

        <Latest />
        <Trending />
        {isAuthenticated() && <WatchList />}
      </div>
    </>
  );
};
export default MovieContainer;
